import React from "react";
import { FieldType, TabsData } from "../../../../../../types/bigForm";
import classes from "../../../../OrderBody.module.scss";
import Fields from "../../Fields";

type Props = {
  modalField: FieldType;
  modalName: string;
  propsalId: number; // в новой реализации просто номер шага, потому ниже добавляю реальный id
  propsalIdsReal?: number[];
  tab: string;
  setTab: (tab: string) => void;
  modalIndex?: number;
  tabsData?: TabsData;
  tabsError: string[];
  setOpen: (isOpen: boolean) => void;
  setShowPreloader: (isShow: boolean) => void;
  isMultiple: boolean;
};

const ModalFieldBody: React.FC<Props> = (props) => {
  return (
    <>
      {props.tabsData?.tabs && props.tabsData?.tabs.length > 0
        ? props.tabsData?.tabs.map((tabItem, index) => (
            <React.Fragment key={index}>
              <div className={classes.category}>{tabItem}</div>
              {props.modalField.childs
                .filter((elem) => elem.category === tabItem)
                .map((child) => {
                  return (
                    <Fields
                      key={child.name}
                      field={child}
                      parentName={props.modalField.name}
                      propsalId={props.propsalId}
                      indexGroupField={Number(props.modalIndex)}
                      parentId={props.modalField.fieldId}
                      propsalIdsReal={props.propsalIdsReal}
                      isMultiple={props?.isMultiple}
                    />
                  );
                })}
            </React.Fragment>
          ))
        : props.modalField.childs.map((child) => {
            return (
              <Fields
                key={child.name}
                field={child}
                parentName={props.modalField.name}
                propsalId={props.propsalId}
                indexGroupField={Number(props.modalIndex)}
                parentId={props.modalField.fieldId}
                isMultiple={props?.isMultiple}
              />
            );
          })}
    </>
  );
};

export default React.memo(ModalFieldBody);
